import { render, staticRenderFns } from "./UserPropDetailPanel.vue?vue&type=template&id=5edeef3d&scoped=true"
import script from "./UserPropDetailPanel.vue?vue&type=script&lang=js"
export * from "./UserPropDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./UserPropDetailPanel.vue?vue&type=style&index=0&id=5edeef3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edeef3d",
  null
  
)

export default component.exports